export function sanitizeForSearch(input: string): string {
  return input.replace(/[^0-9a-z]/gi, '').toLowerCase();
}
